
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";

/**
 * GlModuleControlService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class GlModuleControlService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetSettings(): Promise<{ [key: string]: any }> {
        return this.$apiService.sendAuth("IGlModuleControlService/GetSettings");
    }
    SetReportingSettings(): Promise<void> {
        return this.$apiService.sendAuth("IGlModuleControlService/SetReportingSettings");
    }
}
